import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { isJapaneseLocale } from '@/i18n';

dayjs.extend(utc);
dayjs.extend(timezone);

/** Matches backend DEFAULT_TIMEZONE in chaild-api requestContext.ts */
export const DEFAULT_TIMEZONE = 'Asia/Phnom_Penh';

export const formatPickupTime = (time: string): string => {
  return dayjs(time).tz(DEFAULT_TIMEZONE).format('HH:mm');
};

export const formatChatTime = (
  time: string,
  selectedDate: string,
  options?: { multiline?: boolean },
): string => {
  const zoned = dayjs(time).tz(DEFAULT_TIMEZONE);
  const created = zoned.format('YYYY-MM-DD');
  const selected = dayjs(selectedDate).format('YYYY-MM-DD');
  if (created === selected) {
    return zoned.format('HH:mm');
  }
  // JA: MM/DD, otherwise: DD/MM
  const datePart = isJapaneseLocale() ? 'MM/DD' : 'DD/MM';
  return options?.multiline
    ? zoned.format(`${datePart}\nHH:mm`)
    : zoned.format(`${datePart} HH:mm`);
};

export const toPickupISOString = (date: string, timeStr: string): string => {
  const [hour, minute] = timeStr.split(':');
  return dayjs
    .tz(
      `${date} ${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`,
      'YYYY-MM-DD HH:mm',
      DEFAULT_TIMEZONE,
    )
    .toISOString();
};

export const getCurrentPickupTimeDefault = (): string => {
  return dayjs().tz(DEFAULT_TIMEZONE).format('HH:00');
};
